import React, { FunctionComponent } from 'react';

import { forNamespace } from 'app/common/lib/util/i18n';
import {
  PrimaryButton,
  ButtonSizes,
} from 'app/common/components/controls/button/button';

// eslint-disable-next-line @trello/less-matches-component
import styles from './AutomaticOnboardingOverlay.less';
import { MemberAvatarUnconnected } from 'app/src/components/MemberAvatar';
import { Avatars } from '@trello/members';
import { AtlassianAccountOnboardingLinks } from '../../AtlassianAccountOnboardingLinks';
import { identityBaseUrl } from '@trello/config';
import { AutoOnboardingDialog } from '../../AutomaticOnboarding/AtlassianAutomaticOnboardingOverlays/AutoOnboardingDialog';

const format = forNamespace(['aa onboarding', 'dialog'], {
  shouldEscapeStrings: false,
});

interface AutomaticMigrationConfirmationProps {
  avatars: Avatars;
  name: string;
  aaEmail: string;
  orgName?: string;
  onDismiss: () => void;
  onClickOk: () => void;
  onTrackScreenEvent: () => void;
}

export const AutomaticMigrationConfirmation: FunctionComponent<AutomaticMigrationConfirmationProps> = ({
  avatars,
  name,
  aaEmail,
  orgName,
  onDismiss,
  onClickOk,
}) => {
  const manageProfileUrl = aaEmail
    ? `${identityBaseUrl}/login?login_hint=${encodeURIComponent(
        aaEmail,
      )}&continue=${encodeURIComponent(identityBaseUrl + '/manage-profile')}`
    : `${identityBaseUrl}/manage-profile`;

  return (
    <AutoOnboardingDialog
      title={format('youre all set')}
      // Only show the help link for managed accounts
      helpLink={orgName && AtlassianAccountOnboardingLinks.Help}
      closeDialog={onDismiss}
      className={styles.loginWithAtlassianBody}
    >
      <div className={styles.confirmationContent}>
        <div className={styles.leftSection}>
          <MemberAvatarUnconnected size={64} avatars={avatars} />
          <p>{name}</p>
          <span>{aaEmail}</span>
        </div>
        <div className={styles.rightSection}>
          <li key={aaEmail}>
            <span>
              {format('atlassian confirmation first li', {
                aaEmail: <strong key="email">{aaEmail}</strong>,
              })}
            </span>
          </li>
          <li key={orgName}>
            {format('atlassian confirmation second li', { orgName })}{' '}
            <a href={AtlassianAccountOnboardingLinks.TransferBoards}>
              <u> {format('atlassian confirmation leave or transfer')}</u>
            </a>{' '}
            {format('boards not for org', { org: orgName })}
          </li>
          <li key="review your profile">
            <a href={manageProfileUrl}>
              <u> {format('review your atlassian profile')}</u>
            </a>{' '}
            {format('within three days')}
          </li>
        </div>
      </div>
      <div className={styles.confirmationSection}>
        <PrimaryButton size={ButtonSizes.WIDE} onClick={onClickOk}>
          {format('got it')}
        </PrimaryButton>
      </div>
    </AutoOnboardingDialog>
  );
};
